import React, { useState, createContext, useEffect, useContext} from "react"
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import * as jsondiffpatch from 'jsondiffpatch';
import { matchPath } from 'react-router-dom';

import LanguageContext from "./LanguageContext"
import PopupNotifContext from "./PopupNotifContext"


import APIS, { GLB_URL_THESCAN } from "../utils/APIS"
import { isLoggedIn, getCurrentUser, logout, setUser as setUserAuth } from "../utils/auth"

const UserContext = createContext()

export const getPointsByQuizz = (quizz) => {
  var maxPoints = 0
  for (var res of quizz.responses) {
    var pts = parseInt(res.points)
    if (quizz.multi && pts > 0) maxPoints += pts
    if (!quizz.multi && pts > maxPoints) maxPoints = pts
  }

  if (quizz.userChoice === null || quizz.userChoice === undefined) {
    return [0, maxPoints]
  }
  var userPoints = 0
  if (typeof(quizz.userChoice) === "number") {
    let res = quizz.responses[quizz.userChoice]
    if (res && res.points) userPoints += parseInt(res.points)
  } else {
    for (var choice of quizz.userChoice) {
      let res = quizz.responses[choice]
      if (res && res.points) userPoints += parseInt(res.points)
    }
  }

  return [userPoints, maxPoints]
}

const UserProvider = ({ children }) => {
  const navigate = useNavigate();

  const {
    actLanguage,
    changeLanguage,
    languageValues,
  } = useContext(LanguageContext)

  const { addPopupNotif } = useContext(PopupNotifContext)

  const [loaded, setLoaded] = useState(false)
  const [firstLoad, setFirstLoad] = useState(false)

  const [user, setUser] = useState(null)
  const [plan, setPlan] = useState(null)
  const [formation, setFormation] = useState(null)
  const [actIndex, setActIndex] = useState(null)
  const [lastDoneIndex, setLastDoneIndex] = useState(null)

  useEffect(() => {
    if (actLanguage && user?.language) {
      if (actLanguage !== user?.langauge) {
        changeLanguage(user?.language)
      }
    }
  }, [actLanguage, user])


  useEffect(() => {
    if (loaded === false) {
      updateUserContext()
    }
  }, [loaded])

  const updateUserContext = (id, forceRefreshStorage) => {
    if (getCurrentUser()?.type === "theScanCandidat") {
      const matchPathname = matchPath({
        path: "/thescan/:id",
        exact: true,
        strict: false
      }, window?.location?.pathname);
      if (matchPathname && matchPathname?.params?.id) {
        id = matchPathname?.params?.id
      }
    }
    APIS.getAllInfos(id).then((result) => {
      let actUser = getCurrentUser()
      if (actUser.type === "theScanCandidat" && result?.error) {
        window.location.href = GLB_URL_THESCAN;
      }
      if ((actUser.type === "student" && result?.user?.type === 'student') || (actUser.type === "theScanCandidat" && result?.user?.type === 'theScanCandidat')) {
        console.log(result)

        //pour blocage des élèves dans des groupes archivés
        try {
          if (result?.user?.groupes?.length > 0) {
            let grps = result?.user?.groupes
            let findNonArchived = false
            for (let i=0; i<grps.length; i++) {
              if (grps[i]?.id === 1 || grps[i]?.archived === "false") { //soit groupe admin soit non archivé
                findNonArchived = true
                break;
              }
            }
            if (findNonArchived === false) {
              navigate("/noAccess")
              return
            }
          }
        } catch(e) { console.log(e) }

        if (result?.user && result?.plan && result?.formation) {
          setUser(result?.user)
          if (forceRefreshStorage) {
            APIS.getLoginStatus().then(result => {
              if (result?.message == "status" && result?.user) {
                setUserAuth(result?.user)
              }
            })
          }

          setPlan(result?.plan)

          sessionStorage.setItem('saveFormation', JSON.stringify(result?.formation));
          let calcActIndex = calculateLastIndex(result?.formation)
          setFormation(result?.formation)
          setActIndex(calcActIndex)

          setLoaded(true)
        } else {
          addPopupNotif({
            uuid : uuidv4(),
            title : languageValues?.notifError[actLanguage],
            type : "error",
            removeAfter:5000,
          })
          setTimeout(() => {
            logout(() => { document?.location?.reload() })
          }, 3000)
        }
      }
    })
  }

  const calculateLastIndex = (formation) => {
    if (formation.isDone) return { chapitre: 'max', partie: 0, sequence: 0 }

    for (var iChap = 0; iChap < formation.chapitre.length; iChap++) {
      var chapitre = formation.chapitre[iChap]
      for (var iPart = 0; iPart < chapitre.partie.length; iPart++) {
        var partie = chapitre.partie[iPart]
        for (var iSeq = 0; iSeq < partie.sequence.length; iSeq++) {
          if (partie.sequence[iSeq].isDone) continue
          return { chapitre: iChap, partie: iPart, sequence: iSeq }
        }
        if (!partie.isDone) return { chapitre: iChap, partie: iPart, sequence: 0 }
      }
      if (!chapitre.isDone) return { chapitre: iChap, partie: 0, sequence: 0 }
    }

    return { chapitre: 0, partie: 0, sequence: 0 }
  }

  useEffect(() => {
    if (formation) {
      let calcActIndex = calculateLastIndex(formation)
      setLastDoneIndex(calcActIndex)
    }
  }, [formation, actIndex])

  const calculateProgress = (formation) => {
    var data = { total: 0, done: 0 }
    for (var chapitre of formation.chapitre) {
      for (var partie of chapitre.partie) {
        for (var sequence of partie.sequence) {
          data.total++
          if (sequence.isDone) data.done++
        }
      }
    }

    return data.total > 0 ? Math.round((data.done / data.total) * 100) : 0
  }

  const sequencesDataRefacto = (seq) => {
    if (seq.userChoice && seq.userChoice !== null) {
      try {
        seq.userChoice = JSON.stringify(seq.userChoice)
      } catch(e) {
        seq.userChoice = seq.userChoice
      }
    }

    return seq
  }

  const manageFormatResponse = (actFormatVerif, datas) => {
    let actFormat = formation?.chapitre[actIndex?.chapitre].partie[actIndex?.partie].sequence[actIndex?.sequence]
    if (actFormat?.id === actFormatVerif?.id) {
      if (!actFormat?.isDone) {
        for (const key of datas) {
          actFormat[key?.key] = key?.value
        }
        setFormation(formation)
        saveUserFormation(formation)
      }
    } else {
      alert("Erreur !")
    }
  }

  const forceNewIndexes = (newIndexes) => {
    if (newIndexes?.chapitre >= 0 && newIndexes?.partie >= 0 && newIndexes?.sequence >= 0) {
      setActIndex({ chapitre: newIndexes?.chapitre, partie: newIndexes?.partie, sequence: newIndexes?.sequence })
    }
  }

  const manageSlide = (addIndex) => {
    var newIndex = actIndex?.sequence + addIndex
    if (newIndex < 0) { return null }

    let actPart = formation?.chapitre[actIndex?.chapitre].partie[actIndex?.partie]
    if (newIndex >= actPart?.sequence?.length) {
      //on passe à la partie ou au chapitre suivant
      return onIndexChange("next")
    }

    //on passe au format suivant
    return onIndexChange(newIndex)
  }

  const onIndexChange = (newIndex) => {
    if (newIndex !== 'next') {
      return setActIndex({ chapitre: actIndex?.chapitre, partie: actIndex?.partie, sequence: newIndex })
    } else {
      let actFormation = JSON.parse(JSON.stringify(formation))
      actFormation.chapitre[actIndex?.chapitre].partie[actIndex?.partie].isDone = true
      if (actIndex?.partie + 1 >= actFormation.chapitre[actIndex?.chapitre].partie.length) {
        //chapitre terminée
        actFormation.chapitre[actIndex?.chapitre].isDone = true
        if (actIndex?.chapitre + 1 >= actFormation.chapitre.length) {
          //formation terminée
          actFormation.isDone = true
          setFormation(actFormation)
          saveUserFormation(actFormation)
          return setActIndex({ chapitre: "max" , partie: 0, sequence: 0 })
        } else {
          //on va au chapitre suivant
          setFormation(actFormation)
          saveUserFormation(actFormation)
          return setActIndex({ chapitre: actIndex?.chapitre + 1 , partie: 0, sequence: 0 })
        }
      } else {
        //on va à la partie suivante dans le même chapitre
        setFormation(actFormation)
        saveUserFormation(actFormation)
        return setActIndex({ chapitre: actIndex?.chapitre, partie: actIndex?.partie + 1, sequence: 0 })
      }
    }

  }


  const saveUserFormation = async (data) => {
    data.progress = calculateProgress(data)
    let actFormation = JSON.parse(JSON.stringify(data))
    let compareForSave = JSON.parse(sessionStorage.getItem('saveFormation'))


    actFormation.chapitre.forEach((chap, indexChap) => {
      chap.partie.forEach((part, indexPart) => {
        part.sequence.forEach((seq, indexSeq) => {
          seq = sequencesDataRefacto(seq)
        })
      })
    })


    compareForSave.chapitre.forEach((chap, indexChap) => {
      chap.partie.forEach((part, indexPart) => {
        part.sequence.forEach((seq, indexSeq) => {
          seq = sequencesDataRefacto(seq)
        })
      })
    })

    var diffpatcher = jsondiffpatch.create({
      cloneDiffValues: true,
      propertyFilter: function(name, context) {
        if (name !== 'color') {
          return name;
        }
      },
      objectHash: function(obj, index) {
        return obj.id || '$$index:' + index;
      },
      arrays: {
          // default true, detect items moved inside the array (otherwise they will be registered as remove+add)
          detectMove: true,
          // default false, the value of items moved is not included in deltas
          includeValueOnMove: false,
      },
      textDiff: {
          minLength: 99999999999999,
      },
    });
    let delta = diffpatcher.diff(compareForSave, actFormation);
    if (delta) {
      let deltaFormat = jsondiffpatch.formatters.jsonpatch.format(delta)
      //console.log(deltaFormat)
      let changesArray = []
      //console.log(deltaFormat)
      deltaFormat.forEach((change) => {
        if (change.op === "replace") {
          let infosUpdate = deltaPathToElementReplace(actFormation, change.path)
          //console.log(infosUpdate)
          //console.log("change "+infosUpdate.type+" with resultID "+infosUpdate.el.resultID+", key "+infosUpdate.key+" to "+change.value)
          changesArray.push(async function() {
            return await APIS.editFormationResult(
              infosUpdate.el.id, //elementID (content)
              infosUpdate.type,
              {
                [infosUpdate.key] : change.value
              }
            )
          })
        }
      });


      if (changesArray.length > 0) {
        //console.log(changesArray)
        const results = await Promise.all(changesArray.map(f => f()));
        sessionStorage.setItem('saveFormation', JSON.stringify(data));
      }
    }

  }

  const deltaPathToElementReplace = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let keyToChange = pathArr[pathArr.length - 1]
    let element = {...formation};

    for (let i=0; i<pathArr.length-1; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type : pathArr[pathArr.length-3] || 'content', key : keyToChange})
  }


  const getFormationResults = () => {
    let glbMasterPond = []
    if (formation.glbMasterPond !== null) {
      glbMasterPond = JSON.parse(formation.glbMasterPond)
    }
    var categories = {master: { quizz : 0, questionnaireV2 : 0, points: 0, max: 0, score: 0 }}
    categories.glbMaster = { quizz : 0, questionnaireV2 : 0, points: 0, max: 0, score: 0 }
    const manageFormat = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        const [points, max] = getPointsByQuizz(format)
        const makeResult = (c, points, max, format) => {
          let newPoints = c.points+points
          let newMax = c.max+max
          return {
            quizz : ['Quizz'].includes(format.type) ? c.quizz + 1 : c.quizz,
            questionnaireV2 : ['QuestionnaireV2'].includes(format.type) ? c.questionnaireV2 + 1 : c.questionnaireV2,
            points : newPoints,
            max : newMax,
            score : Math.round((newPoints / newMax) * 100)
          }
        }
        const makeResultGlbMaster = (c, points, max, format) => {
          //on cherche si la categorie est à ignorer ou non
          let statut = "oui"
          let find = glbMasterPond.find((el) => el.key === format.categorie)
          if (find) {
            statut = find.value
          }
          if (statut === "oui") {
            let newPoints = c.points+points
            let newMax = c.max+max
            return {
              quizz : ['Quizz'].includes(format.type) ? c.quizz + 1 : c.quizz,
              questionnaireV2 : ['QuestionnaireV2'].includes(format.type) ? c.questionnaireV2 + 1 : c.questionnaireV2,
              points : newPoints,
              max : newMax,
              score : Math.round((newPoints / newMax) * 100)
            }
          } else {
            return {
              quizz : c.quizz,
              questionnaireV2 : c.questionnaireV2,
              points : c.points,
              max : c.max,
              score : Math.round((c.points / c.max) * 100),
            }
          }
        }
        categories.master = makeResult(categories.master, points, max, format)
        categories.glbMaster = makeResultGlbMaster(categories.glbMaster, points, max, format)
        if (format.categorie && format.categorie !== 'master' && format.categorie !== 'glbMaster') {
          categories[format.categorie] = makeResult(categories[format.categorie] ?? { points: 0, max: 0, score: 0, quizz : 0, questionnaireV2 : 0,  }, points, max, format)
        }
      }
    }

    let allDiagFormats = [];

    for (var iChap in formation.chapitre) {
      for (var iPart in formation.chapitre[iChap].partie) {
        for (var n in formation.chapitre[iChap].partie[iPart].sequence) {
          var format = formation.chapitre[iChap].partie[iPart].sequence[n]
          if (format.type === "Diagnostic") {
            allDiagFormats.push(format)
          }
          manageFormat(format)
        }
      }
    }

    //let lastDiagFormat = allDiagFormats[allDiagFormats.length - 1]

    //on regarde si on est en rattrapage ou non
    let doneInRat = false
    let formationID = formation.id
    let findInPlan = plan?.find((el) => el.id === formationID)
    //console.log(findInPlan)
    if (findInPlan) {
      if (findInPlan.isOpenForRat === true) {
        doneInRat = true
      }
    }

    return {categories : categories, doneInRat : doneInRat}
  }


  return (
    <UserContext.Provider
      value={{
        updateUserContext,
        currentUser : user,
        actPlan : plan,
        actFormation : formation,
        setActFormation : setFormation,
        actIndex,
        lastDoneIndex,
        allLoaded : loaded,
        manageFormatResponse,
        manageSlide,
        saveUserFormation,
        forceNewIndexes,
        getFormationResults,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export default UserContext

export { UserProvider }
